import { render, staticRenderFns } from "./ListSectionEmpty.vue?vue&type=template&id=2685cd46&"
import script from "./ListSectionEmpty.vue?vue&type=script&lang=js&"
export * from "./ListSectionEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports